// API Base URL
import axios from "axios";
const $axios = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});
export { $axios };
